module.exports = {"editorUrl":"https://visualeditor-dev.auryc.com","ravenDSN":"https://74ecd58aadcd4474a8b7e96871b53957@app.getsentry.com/67509","ubaUrlRoot":"https://uba-api.auryc.dev","exitUrl":"http://portal.auryc.dev"}


/*****************
 ** WEBPACK FOOTER
 ** ./src/config/config_server.json
 ** module id = 61
 ** module chunks = 0
 **/